import * as Data from './data-replication';
import * as KratosToken from './kratos-tokens';
import * as LoadoutStat from './loadout-stats';
import * as PowerDice from './power-dice';
import * as Sanitization from './sanitization';
import * as Tags from './tags';

export const Utils = {
    ...Data,
    ...KratosToken,
    ...LoadoutStat,
    ...PowerDice,
    ...Sanitization,
    ...Tags,
};
